/**
 * Color palette for the Office admin surface.
 *
 * Values match the dark base established by `ExperienceShell` so the
 * admin UI feels like a continuation of the existing landing page.
 * Tones are described in oklch where possible to keep saturation
 * stable across the palette.
 */

export const palette = {
    canvas: "oklch(0.12 0.005 260)",
    canvasGlow: "oklch(0.22 0.05 270 / 0.6)",

    surface: "rgba(255, 255, 255, 0.04)",
    surfaceRaised: "rgba(255, 255, 255, 0.06)",
    surfaceInset: "rgba(0, 0, 0, 0.18)",

    border: "rgba(255, 255, 255, 0.10)",
    borderStrong: "rgba(255, 255, 255, 0.18)",
    borderFocus: "oklch(0.78 0.13 260)",

    fg: "oklch(0.95 0 0)",
    fgMuted: "rgba(255, 255, 255, 0.66)",
    fgSubtle: "rgba(255, 255, 255, 0.45)",

    accent: "oklch(0.78 0.13 260)",
    accentBg: "oklch(0.65 0.15 250 / 0.18)",
    accentFg: "oklch(0.90 0.10 260)",

    success: "oklch(0.86 0.11 155)",
    successBg: "oklch(0.62 0.14 155 / 0.18)",

    warn: "oklch(0.90 0.12 85)",
    warnBg: "oklch(0.78 0.13 85 / 0.18)",

    danger: "oklch(0.82 0.15 25)",
    dangerBg: "oklch(0.65 0.18 25 / 0.18)",

    selection: "oklch(0.65 0.15 250)",
} as const;

export type PaletteKey = keyof typeof palette;
